var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 180,
    viewBox: "0 0 186 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3708_125662)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.633 6.36961C100.004 -0.78987 85.9963 -0.78987 75.3668 6.36961L15.5374 46.668C7.03326 52.396 1.95459 61.881 1.95459 72.0126V148.286C1.95459 165.234 15.9155 179 33.1705 179H152.83C170.085 179 184.046 165.234 184.046 148.286V72.0126C184.046 61.881 178.967 52.396 170.463 46.668L110.633 6.36961Z",
    fill: "#56A012",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6154 168.462H118.385M75.3668 6.36961C85.9963 -0.78987 100.004 -0.78987 110.633 6.36961L170.463 46.668C178.967 52.396 184.046 61.881 184.046 72.0126V148.286C184.046 165.234 170.085 179 152.83 179H33.1705C15.9155 179 1.95459 165.234 1.95459 148.286V72.0126C1.95459 61.881 7.03326 52.396 15.5374 46.668L75.3668 6.36961Z",
    stroke: "#56A012",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3708_125662"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 186,
    height: 180,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.4a76e6d0d84db08590c73774b927bb87.svg";
export { ForwardRef as ReactComponent };